import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { getNodes, getPageTree } from '../utils/contentful';
import Page from '../components/Page';
import Services from '../components/Services';
import styles from './Homepage.module.scss';

HomepageTemplate.propTypes = {
  data: PropTypes.shape({
    page: PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.shape({
        childMarkdownRemark: PropTypes.shape({
          html: PropTypes.string,
        }).isRequired,
      }).isRequired,
      image: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }).isRequired,
      }),
    }).isRequired,
    pages: PropTypes.shape({}).isRequired,
    servicesPage: PropTypes.shape({}).isRequired,
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default function HomepageTemplate({ data: { page: { title, content, image }, pages, servicesPage }, location }) {
  pages = getNodes(pages);
  const services = servicesPage.subpages;

  return (
    <Page
      title={title}
      imageUrl={image && image.file.url}
      pages={pages}
      location={location}
    >
      <article dangerouslySetInnerHTML={{ __html: content.childMarkdownRemark.html }} />
      {/*
      <Link className={styles.locations} to="/company/where-we-work/">
        <span>Over the years, we’ve operated on hundreds of sites!</span>
        <span><strong>Explore interactive map →</strong></span>
      </Link>
      */}
      <div className={styles.services}>
        <Services services={services} />
      </div>
    </Page>
  );
}

export const pageQuery = graphql`
  query HomepageQuery($slug: String!) {
    page: contentfulPage(slug: { eq: $slug }) {
      title
      content {
        childMarkdownRemark {
          html
        }
      }
      image {
        file {
          url
        }
      }
    }
    pages: allContentfulPage(limit: 1000) {
      edges {
        node {
          id
          slug
          title
          subpages {
            id
            slug
          }
        }
      }
    }
    servicesPage: contentfulPage(slug: { eq: "services" }) {
      subpages {
        id
        slug
        title
        content {
          childMarkdownRemark {
            html
          }
        }
        image {
          file {
            url
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/Homepage.js